export default {
    animations: [],
    saving: [],
};